export default {
    animations: [],
    saving: [],
};